import { createIsomorphicFn } from "@tanstack/react-start";
import { Env } from "./types";

const getEnvFn = createIsomorphicFn()
  .server(() => {
    return { ...process.env, ...import.meta.env };
  })
  .client(() => import.meta.env);

export const getEnv: Env = new Proxy({} as Env, {
  get(_, name: string) {
    const env = getEnvFn();
    return env[name];
  },
});
